import React from 'react';
import { Container, Row, Col, Button } from 'react-bootstrap';

import './styles/inviteintro.css';

export default function InviteIntro() {
  return (
    <>
      <div className="invite_intro m-3">
        <Container>
            <Row>
                <Col>
                  <div className="invite_intro_content">
                    <div className="invite_intro_head text-center">
                      <h2>Invite Friends and Earn Crypto Together</h2>
                    </div>
                    <div className="invite_intro_para d-flex justify-content-center align-items-center gap-2">
                      <p>Up to <span className='invite_para_span'>40%</span> Trading Rebate</p>
                      <a className='invite_intro_link m-0' href="http://" target="_blank">Referral Rules </a>
                    </div>
                    <div className="invite_intro_btn text-center">
                        <Button>Invite now</Button>
                    </div>
                  </div>
                </Col>
            </Row>
        </Container>
      </div>
    </>
  )
}
